export const LOCATION_ADDRESS = '300 W Somerdale Rd, Suite 5E, Voorhees Township, NJ 08043';
export const LOCATION_LINK = 'https://goo.gl/maps/hwRLsbyHSchnzg1f7';

export const INSTAGRAM_LINK = 'https://www.instagram.com/utilities.one.group/';

export const INSTAGRAM = 'https://www.instagram.com';
